import React from "react";
import { Outlet } from "react-router-dom";
import "./PlatformLayout.scss";
import { PlatformShellProvider } from "./PlatformShellContext";
import { PlatformTopBar } from "./PlatformTopBar";

export const PlatformLayout: React.FC = () => {
    return (
        <PlatformShellProvider>
            <div className="PlatformLayout-root">
                <PlatformTopBar />
                <Outlet />
            </div>
        </PlatformShellProvider>
    );
};
